import LimitSourceBadge from './LimitSourceBadge';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getBackendURL } from '../../utils/backendURL';

export default function TrialEntitlementSummary({ user }) {
  const [state, setState] = useState(null);
  useEffect(() => {
    let mounted = true;
    const load = () => axios.get(`${getBackendURL()}/api/team/capacity`)
      .then(({ data }) => { if (mounted) setState(data); }).catch(() => {});
    load(); const timer = setInterval(load, 30000);
    return () => { mounted = false; clearInterval(timer); };
  }, [user?.id]);
  if (!state?.trial_ends_at) return null;
  return <aside className="border border-amber-200 bg-amber-50 p-4 rounded-lg mb-4">
    <strong>Complimentary Business Trial</strong>
    <p>{state.executions_limit} executions/month · {state.limit === -1 ? 'Unlimited' : state.limit} team members <LimitSourceBadge source={state.limit_source} /></p>
    <p>Ends {new Date(state.trial_ends_at + (/Z$/.test(state.trial_ends_at) ? '' : 'Z')).toLocaleDateString()}.
      Without a paid plan, the next team limit is {state.limit_after_trial === -1 ? 'Unlimited' : state.limit_after_trial}.</p>
    {state.limit_after_trial !== -1 && state.members.length > state.limit_after_trial && <p>
      Your team exceeds that limit. The owner can choose which members keep access in Team Management, or upgrade the plan.
    </p>}
  </aside>;
}
